import { check, checkAsync, email, nonEmpty, optional, pipe, pipeAsync, string, toLowerCase, trim } from "valibot";

export const EmailSchema = pipe(
  string("Adresse e-mail requise"),
  trim(),
  nonEmpty("Adresse e-mail requise"),
  toLowerCase(),
  email("Adresse e-mail invalide"),
);

export const PhoneSchema = pipeAsync(
  string("Numéro de téléphone requis"),
  nonEmpty("Numéro de téléphone requis"),
  check((input) => input.startsWith("+"), "Sélectionnez votre indicatif pays"),
  checkAsync(async (input) => {
    const { isValidPhoneNumber } = await import("libphonenumber-js");
    return isValidPhoneNumber(input);
  }, "Numéro de téléphone invalide"),
);

export const OptionalPhoneSchema = pipeAsync(
  optional(string("Numéro de téléphone")),
  check((input) => (!!input ? input.startsWith("+") : true), "Sélectionnez votre indicatif pays"),
  checkAsync(async (input) => {
    if (!input) {
      return true;
    }
    const { isValidPhoneNumber } = await import("libphonenumber-js");
    return isValidPhoneNumber(input);
  }, "Numéro de téléphone invalide"),
);
